import { WarningIcon } from 'components/icons'
import Button from 'components/inputs/button'
import { FC } from 'react'

interface Props {
  title?: string
  message?: string
  previous?: string
  previousMessage?: string
}

const ErrorPage: FC<Props> = ({
  title = 'An error has occurred',
  message = 'An unexpected error has occurred.',
  previous,
  previousMessage,
}) => (
  <div className="mx-auto mt-16 flex w-full flex-1 flex-row rounded-lg border border-gray-100 bg-white text-left sm:flex-col md:w-1/2">
    <section className="p-4 md:p-8">
      <div className="flex w-full items-center">
        <WarningIcon className="w-10 shrink-0 text-warning md:w-12" />
        <div
          data-cy="error-message"
          className="ml-4 flex-1 border-l border-gray-100 py-3 pl-6 text-gray-400 dark:border-gray-500 dark:text-gray-200 md:ml-6">
          <h1 className="font-display text-3xl font-normal text-gray-600 dark:text-gray-100">
            {title}
          </h1>
          <p className="mt-2 leading-6 text-primary dark:text-gray-300">
            {message}
          </p>
        </div>
      </div>
      {previous && (
        <Button
          secondary
          asLink
          href={previous}
          className="ml-24 mt-4 inline-block">
          {previousMessage || 'Go back'}
        </Button>
      )}
    </section>
  </div>
)

export default ErrorPage
